import React, { useState } from 'react'
import { ModalDialog } from 'uiComponents/popups/modal'
import { DiscountPool } from 'discounts/types'
import AddPoolForm from './addPoolForm'
import AddPoolSuccessful from './addPoolSuccessful'
import { removeHash } from 'utils/hash'

export const AddPoolModal: React.FC = () => {
    const [showSuccess, setShowSuccess] = useState<boolean>(false)
    const [pool, setPool] = useState<DiscountPool>()

    return (
        <ModalDialog onDismiss={removeHash} interactive style={{ width: 576 }}>
            {showSuccess ? (
                <AddPoolSuccessful pool={pool} />
            ) : (
                <AddPoolForm
                    onPoolAdd={(pool) => {
                        setPool(pool)
                        setShowSuccess(true)
                    }}
                />
            )}
        </ModalDialog>
    )
}
